import React, { useState, useEffect  } from 'react';
import TextField from '@mui/material/TextField';
import setSourceAction from '../../redux/actions/createReferenceActions/actionSource';
import { styled } from '@mui/system';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

const StyledTextField = styled(TextField)({
        "&:hover ": {
            borderColor: "rgb(0,191,255)"
        },
        '& label.Mui-focused': {
            color: 'white'
        },
        "& .Mui-focused ": {
            color: 'white'
        },
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgb(0,191,255)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgb(47, 79, 79)',
            },
        },
  });
  

export default function SourceForm(props) {

    // const classes = useStyles(props);
    const selectedReferenceData = useSelector(state => state.showRefState.selectedReferenceData)
    const [source, setSource] = useState("");
    const dispatch = useDispatch()
    const { t } = useTranslation();
      
    useEffect(() => {
        
        if(selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            if (selectedReferenceData.source === "" || selectedReferenceData.source == null) {
                setSource(" ")
            } else {
                setSource(selectedReferenceData.source);
            }
        } 
      },[]);

      useEffect(() => {
        
        dispatch(setSourceAction(source))

      },[source]);

    const handleChange = (event) => {
        
        setSource(event.target.value);

        }

    return (
        <div>
          <StyledTextField value={source} inputProps={{ maxLength: 30 }} label={t('edit_ref.source')} variant="outlined" 
             style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }} onChange={handleChange}/>
        </div>
      );
}